import { skip, mapIndexed } from "../../../../fable_modules/fable-library.3.7.9/Array.js";
import { join, split } from "../../../../fable_modules/fable-library.3.7.9/String.js";
import { map as map_1, value as value_49 } from "../../../../fable_modules/fable-library.3.7.9/Option.js";
import { indexed, cons, tail, map as map_2, head, isEmpty, collect, empty as empty_1, tryFindIndex, item, ofArray, contains } from "../../../../fable_modules/fable-library.3.7.9/List.js";
import { createObj, stringHash } from "../../../../fable_modules/fable-library.3.7.9/Util.js";
import { createElement } from "react";
import { map, toArray, empty, singleton, append, delay, toList } from "../../../../fable_modules/fable-library.3.7.9/Seq.js";
import { SyntaxNode, Corpus__get_SharedInfo } from "../../../Model/Model.js";
import { matches as matches_1, isMatch as isMatch_1, match, split as split_1 } from "../../../../fable_modules/fable-library.3.7.9/RegExp.js";
import { separatorRow, ResultLineFields, textColumns, idColumn } from "./Common.js";
import { Interop_reactApi } from "../../../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { FSharpSet__Contains } from "../../../../fable_modules/fable-library.3.7.9/Set.js";
import { FSharpMap__get_Item } from "../../../../fable_modules/fable-library.3.7.9/Map.js";
import { StringUtils_replace } from "../../../../Shared/Shared.js";
import { parse } from "../../../../fable_modules/fable-library.3.7.9/Int32.js";
import syntax_tree from "../../../../../syntax_tree.jsx";
import { Helpers_combineClasses } from "../../../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";

export function concordanceTable(model, corpus, pageResults, loadedCorpusDispatch, dispatch) {
    let elems_5;
    const processField = (displayedAttributeIndex, maybeOrigCorrIndex, maybeLemmaIndex, field) => mapIndexed((index, token) => {
        if (token.indexOf("/") >= 0) {
            let attributes;
            let attrs_1;
            const attrs = split(token, ["/"], null, 0);
            if (maybeOrigCorrIndex == null) {
                attrs_1 = attrs;
            }
            else {
                const _origCorrIndex = value_49(maybeOrigCorrIndex);
                attrs_1 = mapIndexed((_attrIndex, attr) => attr, attrs);
            }
            if (maybeLemmaIndex == null) {
                attributes = attrs_1;
            }
            else {
                const lemmaIndex = maybeLemmaIndex | 0;
                attributes = mapIndexed((attrIndex, attr_1) => {
                    if (attrIndex === lemmaIndex) {
                        return `"${attr_1}"`;
                    }
                    else {
                        return attr_1;
                    }
                }, attrs_1);
            }
            const tipText = join(" ", attributes.filter((attr_2) => (!contains(attr_2, ofArray(["__UNDEF__", "\"__UNDEF__\"", "-", "_", "\"_\"", "\u003ci\u003e_\u003c/i\u003e"]), {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            }))));
            return createElement("span", createObj(toList(delay(() => append(singleton(["key", index]), delay(() => append(singleton(["data-tooltip", tipText]), delay(() => append(singleton(["className", "has-tooltip-arrow"]), delay(() => {
                let matchValue, fontFamily;
                return append((matchValue = Corpus__get_SharedInfo(corpus).FontFamily, (matchValue == null) ? ((empty())) : ((fontFamily = matchValue, singleton(["style", {
                    fontFamily: fontFamily,
                }])))), delay(() => {
                    let content;
                    return singleton((content = (attributes[displayedAttributeIndex] + " "), ["dangerouslySetInnerHTML", {
                        __html: content,
                    }]));
                }));
            }))))))))));
        }
        else {
            return createElement("span", {
                key: index,
                children: `${token} `,
            });
        }
    }, split_1(field, "\\s+"));
    const extractFields = (resultText) => {
        const groups = match(/^<s_id\s+(.*?)>:\s+(.*)\{\{(.+?)\}\}(.*?)$/g, resultText);
        return [groups[1] || "", groups[2] || "", groups[3] || "", groups[4] || ""];
    };
    const mainRow = (resultLineFields, index_2) => {
        const children = toList(delay(() => {
            let elems_2;
            return append(singleton(createElement("td", createObj(ofArray([["style", {
                textAlign: "center",
                verticalAlign: "middle",
            }], (elems_2 = [idColumn(corpus, model, resultLineFields.SId, "", void 0, index_2, loadedCorpusDispatch, dispatch)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => textColumns(resultLineFields)));
        }));
        return createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        });
    };
    const syntaxRow = (model_1, rowIndex) => {
        let elems_4;
        const key_20 = `${model_1.ResultPageNo}_${rowIndex}`;
        if (FSharpSet__Contains(model_1.VisibleSyntaxTreeKeys, key_20)) {
            const tokens = skip(3, split(item(0, FSharpMap__get_Item(model_1.ResultPages, model_1.ResultPageNo)[rowIndex].Text), []));
            let nodes;
            let isMatch = false;
            nodes = toArray(delay(() => map((token_1) => {
                if (isMatch_1(/^\{\{/g, token_1)) {
                    isMatch = true;
                }
                const attrs_2 = split(StringUtils_replace("\\}\\}$", "", StringUtils_replace("^\\{\\{", "", token_1)), ["/"], null, 0);
                const orthographicForm = attrs_2[0];
                const partOfSpeech = attrs_2[2];
                const synFunc = attrs_2[attrs_2.length - 3];
                const result = new SyntaxNode(parse(attrs_2[attrs_2.length - 2], 511, false, 32), orthographicForm, partOfSpeech, parse(attrs_2[attrs_2.length - 1], 511, false, 32), synFunc, isMatch);
                if (isMatch_1(/\}\}$/g, token_1)) {
                    isMatch = false;
                }
                return result;
            }, tokens)));
            return createElement("tr", createObj(ofArray([["key", `syntax_${key_20}`], (elems_4 = [createElement("td", {
                colSpan: 4,
                style: {
                    maxWidth: 1100,
                },
                children: createElement(syntax_tree, {
                    cnl: nodes,
                }),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
        }
        else {
            return null;
        }
    };
    let patternInput_2;
    const matchValue_2 = Corpus__get_SharedInfo(corpus).LanguageConfig;
    if (matchValue_2.tag === 1) {
        throw (new Error("NOT IMPLEMENTED"));
    }
    else {
        const maybeLangAttributes = matchValue_2.fields[0];
        if (maybeLangAttributes == null) {
            patternInput_2 = [void 0, void 0];
        }
        else {
            const attributes_1 = maybeLangAttributes;
            patternInput_2 = [map_1((i) => (i + 1), tryFindIndex((attr_3) => (attr_3.Code === "lemma"), attributes_1)), map_1((i_1) => (i_1 + 1), tryFindIndex((attr_4) => (attr_4.Code === "orig"), attributes_1))];
        }
    }
    const rows = (pageResults == null) ? empty_1() : collect((tupledArg) => {
        const rowIndex_1 = tupledArg[0] | 0;
        const maybeLemmaIndex_2 = patternInput_2[0];
        const maybeOrigCorrIndex_2 = patternInput_2[1];
        const wordIndex = 0;
        const matchValue_1 = tupledArg[1].Text;
        let pattern_matching_result, mainLine_1, otherLines_1;
        if (!isEmpty(matchValue_1)) {
            if (isEmpty(tail(matchValue_1))) {
                pattern_matching_result = 0;
                mainLine_1 = head(matchValue_1);
                otherLines_1 = tail(matchValue_1);
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const patternInput = extractFields(mainLine_1);
                const searchWord_1 = patternInput[2];
                const sId_1 = patternInput[0];
                const pre_1 = patternInput[1];
                const post_1 = patternInput[3];
                const wordRow = mainRow(new ResultLineFields(sId_1, processField(wordIndex, maybeOrigCorrIndex_2, maybeLemmaIndex_2, pre_1), processField(wordIndex, maybeOrigCorrIndex_2, maybeLemmaIndex_2, searchWord_1), processField(wordIndex, maybeOrigCorrIndex_2, maybeLemmaIndex_2, post_1)), rowIndex_1);
                if (maybeOrigCorrIndex_2 == null) {
                    return toList(delay(() => append(singleton(wordRow), delay(() => (Corpus__get_SharedInfo(corpus).IsTreebank ? singleton(syntaxRow(model, rowIndex_1)) : empty())))));
                }
                else {
                    const origCorrIndex = maybeOrigCorrIndex_2 | 0;
                    const processedOrigFields = new ResultLineFields(sId_1, processField(origCorrIndex, wordIndex, maybeLemmaIndex_2, pre_1), processField(origCorrIndex, wordIndex, maybeLemmaIndex_2, searchWord_1), processField(origCorrIndex, wordIndex, maybeLemmaIndex_2, post_1));
                    return toList(delay(() => append(singleton(wordRow), delay(() => {
                        let elems_3;
                        return append(singleton(createElement("tr", createObj(ofArray([["key", `orig${rowIndex_1}`], (elems_3 = toList(delay(() => append(singleton(createElement("td", {
                            style: {
                                verticalAlign: "middle",
                            },
                        })), delay(() => textColumns(processedOrigFields))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append(Corpus__get_SharedInfo(corpus).IsTreebank ? singleton(syntaxRow(model, rowIndex_1)) : empty(), delay(() => singleton(separatorRow(rowIndex_1))))));
                    }))));
                }
            }
            case 1: {
                if (isEmpty(matchValue_1)) {
                    return empty_1();
                }
                else {
                    const patternInput_1 = extractFields(head(matchValue_1));
                    return cons(mainRow(new ResultLineFields(patternInput_1[0], processField(wordIndex, maybeOrigCorrIndex_2, maybeLemmaIndex_2, patternInput_1[1]), processField(wordIndex, maybeOrigCorrIndex_2, maybeLemmaIndex_2, patternInput_1[2]), processField(wordIndex, maybeOrigCorrIndex_2, maybeLemmaIndex_2, patternInput_1[3])), rowIndex_1), map_2((line) => {
                        let elems_1;
                        const matches = matches_1(/<(\w+_id)\s*(.+?)>(.*?)<\/\1>/g, line);
                        const components = (matches.length > 0) ? toArray(map((m) => {
                            const value_12 = `${m[2]}: ${m[3]}`;
                            return createElement("span", {
                                children: [value_12],
                            });
                        }, matches)) : processField(0, maybeOrigCorrIndex_2, maybeLemmaIndex_2, line);
                        return createElement("tr", createObj(ofArray([["key", rowIndex_1], (elems_1 = [createElement("td", {}), createElement("td", {
                            colSpan: 3,
                            children: Interop_reactApi.Children.toArray(Array.from(components)),
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
                    }, tail(matchValue_1)));
                }
            }
        }
    }, indexed(ofArray(pageResults)));
    const props_13 = ofArray([["className", "is-fullwidth"], ["className", "is-bordered"], ["className", "is-narrow"], ["className", "concordance-table"], (elems_5 = [createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(rows)),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]);
    return createElement("table", createObj(Helpers_combineClasses("table", props_13)));
}

